import { ApiClient } from '@/config/axios.config';
import type { CargoCountResult } from '@/types/cargoCount.types';

/**
 * Cargo Count API Service
 * Handles all cargo count data retrieval operations
 */
export class CargoCountService {
  private static readonly BASE_PATH = '/cargocount';

  /**
   * Fetch cargo count data for all areas and periods
   * @returns Promise<CargoCountResult[]> Array of cargo count records
   */
  static async getCargoCount(): Promise<CargoCountResult[]> {
    try {
      const data = await ApiClient.get<CargoCountResult[]>(this.BASE_PATH);
      return data;
    } catch (error) {
      console.error('CargoCountService: Failed to fetch cargo count data', error);
      throw error;
    }
  }
}
